import React, { Component } from "react";
import FlexView from "react-flexview";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import Container from "../../../../../modules/commons/Container";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import ReportStatisticProspectToday from "./components/reportStatisticProspectToday";
import ReportAppointmentFollowupToday from "./components/reportAppointmentFollowupToday";
import ReportAppointmentOverdue from "./components/reportAppointmentOverdue";
import { mapToObjectDDL } from "../../../../common/mapper";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import { connect } from "react-redux";
import * as ErrorAction from "../../../../../Redux/ErrorRedux";
import { HttpStatus } from "../../../../common/Constants";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";

class DashboardCrmCoordinatorDailyReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataCabang: [],
      kodeCabang: null,
      search: {
        kodeCabang: null,
        teamLeader: null,
      },
      teamLead: null,
      listTeamLead: [],
      loading: false,
      doSearch: false
    };
  }

  componentDidMount = async () => {
    this.fetchDataCabang();
  };

  handleChangeSearchValue = (name, value) => {
    if(name === 'kodeCabang'){
      if(value){
        this.fetchTeamLeaderData(value.value)
      }
      this.setState((prevValue) => ({
        ...prevValue,
        teamLead: null,
        [name]: value,
      }));
    }else{
      this.setState((prevValue) => ({
        ...prevValue,
        [name]: value,
      }));
    }
  };

  fetchDataCabang = async () => {
    try {
      this.handleTriggerLoading();
      let res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
        setError: this.props.setError,
        menuName:
          "Dashboard Level Kepala Cabang Keatas dan Admin CRM - Laporan Prspek Monitoring Tim",
        args: null,
      });
      if (res.ok) {
        let filteredData = res.data.data.filter((item) =>
          this.props.menuAccess
            .map((data) => data.idRefObj)
            .includes(item.kodeCabang)
        );
        if (filteredData.length !== 0) {
          this.setState((prevValue) => ({
            ...prevValue,
            dataCabang: filteredData,
            kodeCabang: mapToObjectDDL(filteredData[0].namaDealer, filteredData[0].kodedecang),
          }));
          this.fetchTeamLeaderData(filteredData[0].kodeCabang);
        }
      }
      this.handleTriggerLoading();
    } catch (error) {
      this.handleTriggerLoading();
      console.log("errors", error);
    }
  };

  fetchTeamLeaderData = async (kodeCabang) => {
    try {
      this.handleTriggerLoading();
      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterSales,
        setError: this.props.setError,
        menuName:
          "Dashboard Level Team Leader - Laporan Statistik Prospek Per Team Leader",
        args: { paramFilters: { kodeCabang, userNameLead: this.props.auth?.user?.username } },
      });
      if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        this.setState((prevValue) => ({
          ...prevValue,
          listTeamLead: res.data.data,
        }));
      }
      this.handleTriggerLoading();
    } catch (error) {
      this.handleTriggerLoading();
      console.log("errors", error);
    }
  };

  handleSearch = () =>{
    this.setState(prev=>({
      ...prev,
      search:{
        kodeCabang:this.state.kodeCabang?.value,
        teamLeader:this.state.teamLead?.value
      },
      doSearch: true
    }))
  }

  handleTriggerLoading = () => {
      this.setState((prevValue) => ({ ...prevValue, loading: !prevValue.loading }));
  };

  handleSuccessSearch = () => {
    this.setState({
      doSearch: false
    })
  }

  render() {
    return (
      <div>
        <Container>
          <FlexView style={{ gap: "20px", alignItems: "center" }}>
            <FlexView style={{ gap: "20px", alignItems: "flex-end" }}>
              <SimpleDDL
                id="select_options_branch"
                box="search"
                label="Cabang"
                placeholder="CABANG"
                name="kodeCabang"
                isClearable
                containerclassname="width width-250px"
                options={this.state.dataCabang.map((item) =>
                  mapToObjectDDL(item.namaDealer, item.kodeCabang)
                )}
                value={this.state.kodeCabang}
                onChange={(value, { name }) =>
                  this.handleChangeSearchValue(name, value)
                }
              />
              <SimpleDDL
                id="select_options_tl_name"
                box="search"
                name="teamLead"
                containerclassname="width width-250px"
                placeholder="Nama TL"
                menuPosition="fixed"
                isClearable
                options={this.state.listTeamLead.map((item) =>
                  mapToObjectDDL(item.salesLeadName, item.employeeId)
                )}
                value={this.state.teamLead}
                onChange={(value, { name }) =>
                  this.handleChangeSearchValue(name, value)
                }
              />
            </FlexView>
            <SimpleButton onClick={() => this.handleSearch()}>
              Cari
            </SimpleButton>
          </FlexView>
          <Tabs>
            <TabList>
              <Tab style={{ width: "150px", textAlign: "center" }}>
                Laporan Statistik Prospek Today
              </Tab>
              <Tab style={{ width: "200px", textAlign: "center" }}>
                Laporan Appointment Follow Up Hari Ini
              </Tab>
              <Tab style={{ width: "200px", textAlign: "center" }}>
                Laporan Appointment Overdue
              </Tab>
            </TabList>
            <TabPanel>
              <ReportStatisticProspectToday
                {...this.props}
                search={this.state.search}
                doSearch={this.state.doSearch}
                triggerLoading={this.handleTriggerLoading}
                onSuccessSearch={this.handleSuccessSearch}
              />
            </TabPanel>
            <TabPanel>
              <ReportAppointmentFollowupToday
                {...this.props}
                search={this.state.search}
                doSearch={this.state.doSearch}
                triggerLoading={this.handleTriggerLoading}
                onSuccessSearch={this.handleSuccessSearch}
              />
            </TabPanel>
            <TabPanel>
              <ReportAppointmentOverdue
                {...this.props}
                search={this.state.search}
                doSearch={this.state.doSearch}
                triggerLoading={this.handleTriggerLoading}
                onSuccessSearch={this.handleSuccessSearch}
              />
            </TabPanel>
          </Tabs>
          {this.state.loading && (
            <SimpleLoadingOverlay active={this.state.loading} />
          )}
        </Container>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
  }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardCrmCoordinatorDailyReport);